import React from 'react'
import {
  Box,
  Text,
  Select,
} from '@usap/uicomponents'
import SetKitDisplay from '../../../../../SetKitDisplay'
import ReturnStatus from '../../../../../ReturnStatus'
import PartNo from './PartNo'
import QuantitySelection from './QuatitySelection'
import UnitPrice from './UnitPrice'
import TotalPrice from './TotalPrice'
import { disableStyle } from '../../constant'
import { setQtyRange } from '../../utils'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import ReturnItemDetailWMO from './ReturnItemDetailWMO'

const ReturnItemDetail = props => {
  const {
    isDesktop,
    orderItems,
    eligibleRMA,
    brandText,
    selectedPart,
    partNumber,
    showTabs,
    removeQtySelect,
    ikey,
    qtyRange,
    qtyToCompute,
    handleQtyChange,
    itemPriceParsed,
    selectedQty,
    imageText,
    itemTotal,
    parentSku,
    etaToShow,
    returnStatusData,
    orderInfo,
    Link,
    creditStatus,
    returnRequestStatus,
    setReturnDetailsData,
    setDisplayReturnDetails,
    returnItemQty,
    showCheckBox,
  } = { ...props }

  const itemWidth = showCheckBox && isDesktop ? '60%' : '100%'

  const isWmoEnabled = useWmoEnabled()

  if(isWmoEnabled) {
    return (
      <ReturnItemDetailWMO {...props} />
    )
  }

  return (
    <Box
      width={isDesktop ? 'large' : 'medium'}
      alignContent="center"
      alignSelf="start"
      margin={{ top: orderItems.length > 1 ? '0px' : '16px' }}
    >
      <Box style={eligibleRMA ? null : disableStyle} direction="row">
        <Box direction="column" style={{ width: itemWidth }}>
          <Text
            size="small"
            color="#333333"
            style={{ fontWeight: 700, lineHeight: 1.5 }}
            dangerouslySetInnerHTML={{ __html: brandText }}
          />
          <Text
            size="small"
            color="#333333"
            style={{ fontWeight: 400, lineHeight: 1.5 }}
            dangerouslySetInnerHTML={{ __html: imageText }}
          />
          {<PartNo selectedPart={selectedPart} partNumber={partNumber} />}
          {showTabs && selectedPart && (
            <QuantitySelection
              eligibleRMA={eligibleRMA}
              partNumber={partNumber}
              setQtyRange={setQtyRange}
              handleQtyChange={handleQtyChange}
              ikey={ikey}
              qtyRange={qtyRange}
              qtyToCompute={qtyToCompute}
            />
          )}
          {!showTabs && !isDesktop && (
            <QuantitySelection
              eligibleRMA={eligibleRMA}
              partNumber={partNumber}
              setQtyRange={setQtyRange}
              handleQtyChange={handleQtyChange}
              ikey={ikey}
              qtyRange={qtyRange}
              qtyToCompute={qtyToCompute}
            />
          )}
          {<UnitPrice itemPriceParsed={itemPriceParsed} />}
          {<TotalPrice
            itemTotal={itemTotal}
            type="noSelectedPartAndNotDesktop"
            showTabs={showTabs}
            selectedPart={selectedPart}
            isDesktop={isDesktop}
          />}
          {<TotalPrice
            itemTotal={itemTotal}
            type="showTabAndSelectedPart"
            showTabs={showTabs}
            selectedPart={selectedPart}
            isDesktop={isDesktop}
          />}
          {isDesktop && !showTabs && parentSku && (
          <SetKitDisplay
            parentSku={parentSku}
            showPartNumber={false}
          />
          )}
        </Box>
        {isDesktop && !showTabs && (
        <>
          <Box style={{ width: '20%' }}>
            <Text
              size="small"
              color="#333333"
              style={{ fontWeight: 400, marginTop: 7, marginBottom: 7 }}
            >
              {!removeQtySelect && (
              <Select
                id={eligibleRMA ? `qty-${partNumber}`: `qty-${partNumber}${ikey}`}
                style={{ width: '40px' }}
                options={setQtyRange(qtyRange)}
                value={qtyToCompute}
                justify="start"
                onChange={({ option }) => handleQtyChange(option)}
                disabled={!eligibleRMA}
              />
              )}
              {removeQtySelect && <>{returnItemQty}</>}
            </Text>
          </Box>
          <Box style={{ width: '20%' }}>
            <Text
              size="small"
              color="#333333"
              style={{ fontWeight: 400, marginTop: 5, marginBottom: 5 }}
            >
              <strong>
                $
                {(itemPriceParsed * selectedQty).toFixed(2)}
              </strong>
            </Text>
          </Box>
        </>
        )}
      </Box>
      {isDesktop && etaToShow}
      { isDesktop && returnStatusData && (
      <ReturnStatus
        returnStatusData={returnStatusData}
        orderDetails={orderInfo}
        Link={Link}
        creditStatus={creditStatus}
        returnRequestStatus={returnRequestStatus}
        setReturnDetailsData={setReturnDetailsData}
        setDisplayReturnDetails={setDisplayReturnDetails}
        isDesktop={isDesktop}
      />
      ) }
    </Box>
  )
}

export default ReturnItemDetail
